window.addEventListener('load', () => {
  function applyColors() {
    const section = document.querySelector('.product__info-container .oke-stars-foreground');
    const visibility = document.querySelector(".product__info-container  .okeReviews.oke-sr");
    if (!section || !visibility) return;
    const fieldColor = getComputedStyle(section)
      .getPropertyValue('--color-foreground')
      .trim();
    if (!fieldColor) return;
    const finalColor = `rgb(${fieldColor})`;
    document.querySelectorAll('.product__info-container .oke-stars-foreground').forEach(el => {
      el.style.setProperty('--oke-stars-foregroundColor', finalColor);
    });
    visibility.style.visibility = "visible";
    visibility.style.opacity = "1";
  }
  applyColors();
  const targetNode = document.body;
  const observer = new MutationObserver(() => {
    applyColors();
  });
  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
});

let selectedQuantity = 1;
let selectedDiscount = 0;

/* ---------------- PRICE HELPERS ---------------- */
function formatPrice(price) {
  const safePrice = Number(price) || 0;

  return FoxTheme.Currency.formatMoney(
    Math.round(safePrice),
    FoxTheme.settings.moneyFormat
  );
}
function safeNumber(value) {
  const num = Number(String(value).replace(/[^0-9.]/g, ""));
  return isNaN(num) ? 0 : num;
}
function normalizePrice(value) {
  const num = safeNumber(value);

  if (num > 0 && num < 1000) {
    return Math.round(num * 100);
  }

  return Math.round(num);
}

function parsePrice(text) {
  if (!text) return 0;
  return Number(text.replace(/[^0-9.]/g, ""));
}

function getFinalPrice(basePrice) {
  if (!basePrice) return 0;

  if (selectedQuantity > 1) {
    return basePrice * (1 - selectedDiscount / 100);
  }

  return basePrice;
}
/* ---------------- MAIN UI & DATA SYNC FUNCTION ---------------- */
function updateSubscriptionUI() {
  const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
  const addToCart = document.querySelector(".add_to_cart");
  const subscriptionBtn = document.querySelector(".subscription_button");

  const oneTimeEls = document.querySelectorAll("[skio-onetime-price]");
  const subEls = document.querySelectorAll("[skio-subscription-price]");
  const priceContainer = document.querySelector(".skio-price");

  const buyerConsent = document.querySelector("#shopify-buyer-consent");
  const subscription_text = document.querySelector(".subscription_text");

  // Sticky bar Selectors
  const stickyBar = document.querySelector('.sticky-atc-bar');
  const stickyForm = document.querySelector('#product-form-sticky-atc-bar');
  const stickyAtcBtnText = stickyBar ? stickyBar.querySelector('.product-form__submit span') : null;
  const stickyPriceLabel = stickyBar ? stickyBar.querySelector('.f-price-item--regular') : null;

  if (!priceContainer) return;

  let oneTimePrice = 0;
  let subPrice = 0;

  /* store base price */
  oneTimeEls.forEach(el => {
    if (!el.dataset.basePrice) {
      const price = parsePrice(el.textContent);
      if (!isNaN(price) && price > 0) el.dataset.basePrice = price;
    }
  });

  subEls.forEach(el => {
    if (!el.dataset.basePrice) {
      const price = parsePrice(el.textContent);
      if (!isNaN(price) && price > 0) el.dataset.basePrice = price;
    }
  });

  if (oneTimeEls.length) oneTimePrice = normalizePrice(oneTimeEls[0].dataset.basePrice);
  if (subEls.length) subPrice = normalizePrice(subEls[0].dataset.basePrice);

  const finalOneTimePrice = getFinalPrice(oneTimePrice);
  const finalSubPrice = getFinalPrice(subPrice);

  /* ---------- RESET ---------- */
  document.querySelectorAll("[skio-discount-diff]").forEach(el => el.remove());
  subEls.forEach(el => el.style.display = "inline-block");

  /* ---------- ONE TIME UI ---------- */
  oneTimeEls.forEach((el) => {
    const basePrice = normalizePrice(el.dataset.basePrice);
    const finalPrice = getFinalPrice(basePrice);
    if (basePrice === finalPrice) {
      el.textContent = formatPrice(finalPrice);
    } else {
      el.innerHTML = `${formatPrice(finalPrice)} <span style="text-decoration: line-through; opacity:0.6; margin-left:6px;">${formatPrice(basePrice)}</span>`;
    }
  });

  /* ---------- SUBSCRIPTION UI ---------- */
  subEls.forEach(subEl => {
    const subBase = normalizePrice(subEl.dataset.basePrice);
    const oneBase = normalizePrice(oneTimePrice);
    if ((selectedQuantity > 1 && oneBase >= subBase) || (selectedQuantity === 1 && oneBase > subBase)) {
      const discounted = getFinalPrice(subBase);
      const diffEl = document.createElement("span");
      diffEl.setAttribute("skio-discount-diff", "true");
      diffEl.style.display = "block";
      diffEl.innerHTML = `<span>${formatPrice(discounted)}</span> <span style="text-decoration: line-through; opacity:0.6; margin-left:6px;">${formatPrice(oneBase)}</span>`;
      subEl.style.display = "none";
      subEl.insertAdjacentElement("afterend", diffEl);
    } else {
      subEl.textContent = formatPrice(getFinalPrice(subBase));
    }
  });

  /* ---------- MODE SWITCH ---------- */
  const isSubscription = sellingPlanInput && sellingPlanInput.value !== "";

  if (isSubscription) {
    // 1. Buttons toggle
    if (addToCart) addToCart.style.display = "none";
    if (subscriptionBtn) subscriptionBtn.style.display = "inline-block";
    
    if (buyerConsent) buyerConsent.style.display = "none";
    if (subscription_text) {
      subscription_text.style.display = "block";
      subscription_text.style.margin = "auto";
    }

    let subHtml = `Subscribe - `;
    if (oneTimePrice > finalSubPrice) {
      subHtml += `<span style="text-decoration: line-through; opacity:0.6; margin-left:2px; margin-right:6px;">${formatPrice(oneTimePrice)}</span><span>${formatPrice(finalSubPrice)}</span>`;
    } else {
      subHtml += `<span>${formatPrice(finalSubPrice)}</span>`;
    }

    if (subscriptionBtn) subscriptionBtn.innerHTML = subHtml;
    if (stickyAtcBtnText) stickyAtcBtnText.innerHTML = subHtml;
    if (stickyPriceLabel) stickyPriceLabel.textContent = formatPrice(finalSubPrice);

  } else {
    // 2. Buttons toggle
    if (subscriptionBtn) {
       subscriptionBtn.style.display = "none";
       subscriptionBtn.innerHTML = ""; 
    }
    if (addToCart) addToCart.style.display = "flex";
    
    if (subscription_text) subscription_text.style.display = "none";
    if (buyerConsent) buyerConsent.style.display = "block";

    let priceHtml = "";
    if (oneTimePrice === finalOneTimePrice) {
      priceHtml = `&nbsp;- <span> ${formatPrice(finalOneTimePrice)}</span>`;
    } else {
      priceHtml = `&nbsp;- <span style="text-decoration: line-through; opacity:0.6; margin-left:2px; margin-right:6px;">${formatPrice(oneTimePrice)}</span><span> ${formatPrice(finalOneTimePrice)}</span>`;
    }


    if (addToCart) {
      let wrapper = addToCart.querySelector(".atc-price");
      if (!wrapper) {
           wrapper = document.createElement("span");
          wrapper.className = "atc-price";
          addToCart.appendChild(wrapper);
      } else {
        wrapper.innerHTML = priceHtml;
      }
    }
    
    if (stickyAtcBtnText) stickyAtcBtnText.innerHTML = `Add to cart ${priceHtml}`;
    if (stickyPriceLabel) stickyPriceLabel.textContent = formatPrice(finalOneTimePrice);
  }

  /* ---------- FORM DATA SYNC ---------- */
  if (stickyForm) {
    let stickySellingInput = stickyForm.querySelector('input[name="selling_plan"]');
    if (isSubscription) {
      if (!stickySellingInput) {
        stickySellingInput = document.createElement('input');
        stickySellingInput.type = 'hidden';
        stickySellingInput.name = 'selling_plan';
        stickyForm.appendChild(stickySellingInput);
      }
      stickySellingInput.value = sellingPlanInput.value;
      stickySellingInput.disabled = false;
    } else {
      if (stickySellingInput) {
          stickySellingInput.value = "";
          stickySellingInput.disabled = true;
      }
    }

    const stickyQtyInput = stickyForm.querySelector('input[name="quantity"]');
    if (stickyQtyInput) stickyQtyInput.value = selectedQuantity;
  }
}
/* ---------------- MAIN UI FUNCTION ---------------- */
// function updateSubscriptionUI() {
  

//   const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
//   const addToCart = document.querySelector(".add_to_cart");
//   const subscriptionBtn = document.querySelector(".subscription_button");

//   const oneTimeEls = document.querySelectorAll("[skio-onetime-price]");
//   const subEls = document.querySelectorAll("[skio-subscription-price]");
//   const priceContainer = document.querySelector(".skio-price");


//    const buyerConsent = document.querySelector("#shopify-buyer-consent");
//    const subscription_text = document.querySelector(".subscription_text");
//   //  const preorder_text = document.querySelector(".preorder-text") 

//   if (!priceContainer) return;

//   let oneTimePrice = 0;
//   let subPrice = 0;

//   /* store base price */
//   oneTimeEls.forEach(el => {
//     if (!el.dataset.basePrice) {
//       const price = parsePrice(el.textContent);
//       if (!isNaN(price) && price > 0) {
//         el.dataset.basePrice = price;
//       }
//     }
//   });

//   subEls.forEach(el => {
//     if (!el.dataset.basePrice) {
//       const price = parsePrice(el.textContent);
//       if (!isNaN(price) && price > 0) {
//         el.dataset.basePrice = price;
//       }
//     }
//   });

// if (oneTimeEls.length) {
//   oneTimePrice = normalizePrice(oneTimeEls[0].dataset.basePrice);
// }

// if (subEls.length) {
//   subPrice = normalizePrice(subEls[0].dataset.basePrice);
// }

//   const finalOneTimePrice = getFinalPrice(oneTimePrice);
//   const finalSubPrice = getFinalPrice(subPrice);

//   /* ---------- RESET ---------- */
//   document.querySelectorAll("[skio-discount-diff]").forEach(el => el.remove());
//   subEls.forEach(el => el.style.display = "inline-block");

//   /* ---------- ONE TIME UI ---------- */
// oneTimeEls.forEach((el, index) => {

//   console.log("----- ONE TIME DEBUG -----");
//   console.log("Element index:", index);
//   console.log("Raw dataset.basePrice:", el.dataset.basePrice);

//   const basePrice = normalizePrice(el.dataset.basePrice);
//   console.log("basePrice (normalized):", basePrice);

//   const finalPrice = getFinalPrice(basePrice);
//   console.log("finalPrice (after discount logic):", finalPrice);

//   console.log("selectedQuantity:", selectedQuantity);
//   console.log("selectedDiscount:", selectedDiscount);

//   console.log("base === final ?", basePrice === finalPrice);

//   if (basePrice === finalPrice) {

//     console.log("CASE: NO DISCOUNT → simple render");

//     const formatted = formatPrice(finalPrice);
//     console.log("formatted finalPrice:", formatted);

//     el.textContent = formatted;
//     console.log("TEXT CONTENT:", el.textContent);
//     console.log("LOCALE:", FoxTheme.settings.moneyFormat);

//   } else {

//     console.log("CASE: DISCOUNT APPLIED → strike UI");

//     const formattedFinal = formatPrice(finalPrice);
//     const formattedBase = formatPrice(basePrice);

//     console.log("formatted final:", formattedFinal);
//     console.log("formatted base:", formattedBase);
    

//     el.innerHTML = `
//       ${formattedFinal}
//       <span style="text-decoration: line-through; opacity:0.6; margin-left:6px;">
//         ${formattedBase}
//       </span>
//     `;
//   }
// });

//   /* ---------- SUBSCRIPTION UI ---------- */
//  subEls.forEach(subEl => {

//  const subBase = normalizePrice(subEl.dataset.basePrice);
// const oneBase = normalizePrice(oneTimePrice);

//   console.log("----- SUBSCRIPTION DEBUG -----");
//   console.log("subBase (subscription):", subBase);
//   console.log("oneBase (one time):", oneBase);
//   console.log("selectedQuantity:", selectedQuantity);
//   console.log("selectedDiscount:", selectedDiscount);

//   const shouldApplyDiscount =
//     selectedQuantity > 1 && oneBase >= subBase;

//   console.log("shouldApplyDiscount:", shouldApplyDiscount);

//   const altCondition =
//     selectedQuantity === 1 && oneBase > subBase;

//   console.log("altCondition:", altCondition);

//   console.log("FINAL CONDITION:", shouldApplyDiscount || altCondition);

//   if (shouldApplyDiscount || altCondition) {

//     const discounted = getFinalPrice(subBase);

//     console.log("discounted price:", discounted);

//     const diffEl = document.createElement("span");
//     diffEl.setAttribute("skio-discount-diff", "true");
//     diffEl.style.display = "block";
//     diffEl.style.marginTop = "4px";

//     diffEl.innerHTML = `
//       <span>${formatPrice(discounted)}</span>
//       <span style="text-decoration: line-through; opacity:0.6; margin-left:6px;">
//         ${formatPrice(oneBase)}
//       </span>
//     `;

//     subEl.style.display = "none";
//     subEl.insertAdjacentElement("afterend", diffEl);

//   } else {

//     console.log("NO DISCOUNT CASE → normal price render");

//     const finalPrice = getFinalPrice(subBase);
//     console.log("final normal price:", finalPrice);

//     subEl.textContent = formatPrice(finalPrice);
//   }
// });

//   /* ---------- MODE ---------- */
//   const isSubscription = sellingPlanInput && sellingPlanInput.value !== "";

//   if (subscriptionBtn) {
//     subscriptionBtn.style.display = isSubscription ? "inline-block" : "none";
//   }

//   if (isSubscription) {

//     if (addToCart) addToCart.style.display = "none";
//     if (buyerConsent) buyerConsent.style.display = "none";
//     // if(preorder_text) preorder_text.style.display="none";

//     if (subscription_text) {
//       subscription_text.style.display = "block";
//       subscription_text.style.margin = "auto";
//     }

//     if (subscriptionBtn) {
//       let html = `Subscribe - `;

//       if (oneTimePrice > finalSubPrice) {
//         html += `
//           <span style="text-decoration: line-through; opacity:0.6; margin-right:6px;">
//             ${formatPrice(oneTimePrice)}
//           </span>
//           <span>${formatPrice(finalSubPrice)}</span>
//         `;
//       } else {
//         html += `<span>${formatPrice(finalSubPrice)}</span>`;
//       }

//       subscriptionBtn.innerHTML = html;
//     }

//   } else {

//     if (addToCart) {
//       addToCart.style.display = "flex";

//       let wrapper = addToCart.querySelector(".atc-price");
      
//       if (subscription_text) {
//       subscription_text.style.display = "none";
//       //  if(preorder_text) preorder_text.style.display="block";
//     }
//       if (!wrapper) {
//         wrapper = document.createElement("div");
//         wrapper.className = "atc-price";
//         addToCart.appendChild(wrapper);
//       }

//       if (oneTimePrice === finalOneTimePrice) {
//         wrapper.innerHTML = `&nbsp;- <span> ${formatPrice(finalOneTimePrice)}</span>`;
//       } else {
//         wrapper.innerHTML = `&nbsp;-
//           <span style="text-decoration: line-through; opacity:0.6; margin-right:6px;">
//             ${formatPrice(oneTimePrice)}
//           </span>
//           <span>- ${formatPrice(finalOneTimePrice)}</span>
//         `;
//       }
//     }
//   }
// }

/* ---------------- INIT ---------------- */
document.addEventListener("DOMContentLoaded", () => {

  const boxes = document.querySelectorAll(".quantity_level_box");
  const quantityInput = document.getElementById("quantity-input");

  /* 👉 quantity selector optional safe handling */
  if (boxes.length && quantityInput) {

    boxes.forEach(box => {
      box.addEventListener("click", function () {

        boxes.forEach(b => b.classList.remove("active"));
        this.classList.add("active");

        selectedQuantity = parseInt(this.dataset.quantity, 10) || 1;
        quantityInput.value = selectedQuantity;

        let percent = 0;
        const match = this.textContent.match(/\d+/);

        if (selectedQuantity > 1 && match) {
          percent = parseInt(match[0]);
        }

        selectedDiscount = percent;

        updateSubscriptionUI();
      });
    });

    /* default update */
    setTimeout(() => {
      const defaultBox = document.querySelector(".quantity_level_box_1");
      if (defaultBox) defaultBox.click();
      else updateSubscriptionUI();
    }, 300);

  } else {
    /* ❗ quantity selector missing → still run UI */
    updateSubscriptionUI();
  }
});
// document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {
//     const oneTimeInput = document.querySelector('input[skio-one-time]');
//     if (oneTimeInput && (!oneTimeInput.value || oneTimeInput.value === "")) {
//       oneTimeInput.checked = true;
//       oneTimeInput.dispatchEvent(new Event("change", { bubbles: true }));
//       oneTimeInput.dispatchEvent(new Event("input", { bubbles: true }));
//     }

//   }, 200);

// });
/* ---------------- CHANGE LISTENER ---------------- */
document.addEventListener("change", function (e) {
  if (
    e.target.matches('input[name^="skio-group"]') ||
    e.target.matches(".skio-frequency") ||
    e.target.matches('input[name="selling_plan"]')
  ) {
    setTimeout(updateSubscriptionUI, 100);
  }
});
document.addEventListener("DOMContentLoaded", function () {

  function addClassToPageWidth() {
    const wonderment = document.querySelector(".wonderment-ab-container");
    
    if (wonderment) {
      let parent = wonderment.closest(".page-width");
      
      if (parent && !parent.classList.contains("tracking-beige-wrapper")) {
        parent.classList.add("tracking-beige-wrapper");
      }
    }
  }
  addClassToPageWidth();
  const observer = new MutationObserver(() => {
    addClassToPageWidth();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

  document.addEventListener('change', async function(e) {
    if (!e.target.classList.contains('upsell-selling-plan-cart')) return;

    const select = e.target;
    const wrapper = select.closest(".subscription-upsell-wrapper");
    const upgradeText = wrapper.querySelector(".upgrade-text");
    const container = wrapper.querySelector(".subscribe_save_container");
    
    const line = parseInt(select.getAttribute('data-line'));
    let sellingPlanId = select.value.trim();
    sellingPlanId = sellingPlanId === '' ? null : parseInt(sellingPlanId);

    // UI Logic: Agar One-time chuna toh text wapas dikhao aur dropdown hide karo
    if (sellingPlanId === null) {
        if(upgradeText) upgradeText.style.display = "block";
        if(container) container.style.display = "none";
    }

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      })
    );

    const body = JSON.stringify({
      line: line,
      quantity: parseInt(select.getAttribute('data-qty') || 1),
      selling_plan: sellingPlanId,
      sections: sectionsToBundle
    });

    try {
        const response = await fetch(`${FoxTheme.routes.cart_change_url}`, {
            ...FoxTheme.utils.fetchConfig(),
            body: body
        });

        if (!response.ok) return;
        const parsedState = await response.json();

        // FoxTheme Update Signal (Drawer + Page smooth refresh)
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          sources: 'cart-items',
          cart: parsedState,
          line: line
        });

        document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: false }
        }));

    } catch (error) {
        console.error('Fetch error:', error);
    }
});

// Click logic (Original)
document.addEventListener("click", function(e){
    const upgradeText = e.target.closest(".upgrade-text");
    if(!upgradeText) return;

    const wrapper = upgradeText.closest(".subscription-upsell-wrapper");
    const loadingText = wrapper.querySelector(".upgrading-text");
    const container = wrapper.querySelector(".subscribe_save_container");
    const select = wrapper.querySelector(".upsell-selling-plan-cart");

    upgradeText.style.display = "none";
    loadingText.style.display = "block";

    setTimeout(() => {
        loadingText.style.display = "none";
        container.style.display = "block";
        if (select) {
            // Subscription optgroup ke andar ka pehla option select karo (index 1, kyunki 0 'One-time' hai)
            const firstPlan = select.querySelector('optgroup[label*="Subscribe"] option');
            if (firstPlan) {
                select.value = firstPlan.value;
                // 'change' event trigger karein taaki aapka fetch wala logic chal jaye
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }, 800); 
});


//============= Start Quantity restriction (Fixed) ==========

document.addEventListener('click', (e) => {
  // Check karo ki click "Plus/Increase" button par hua hai
  const button = e.target.closest('button[name="plus"], .quantity__button[name="plus"]');
  if (!button) return;

  const input = button.parentElement.querySelector('input[name="quantity"], .quantity__input');
  if (input) {
    let currentVal = parseInt(input.value) || 0;
    
    // Agar value 99 ya usse zyada hai, toh further increase ko rok do
    if (currentVal >= 99) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Dusre scripts ko chalne se rokega
      input.value = 99;
    }
  }
}, true); // 'true' yani capture phase mein pakad rahe hain taaki theme script se pehle hum chalein

document.addEventListener('input', (e) => {
  const el = e.target;
  if (el.name === 'quantity' || el.classList.contains('quantity__input')) {
    let val = el.value.replace(/\D/g, '');
    
    if (val !== "") {
      let num = parseInt(val);
      if (num > 99) num = 99;
      if (num < 1) num = 1;
      el.value = num;
    }
  }
});

//============= End Quantity restriction ==========
// function updatePromoMessages() {
//   const cartItems = document.querySelectorAll('.cart-item');

//   cartItems.forEach(item => {
//     const input = item.querySelector('input[name="updates[]"]');
//     if (!input) return;

//     const currentQty = parseInt(input.value);

//     const messages = item.querySelectorAll('.discount-item');

//     messages.forEach(msg => {
//       const requiredQty = parseInt(msg.getAttribute('data-required-qty'));

//       if (currentQty === requiredQty) {
//         msg.style.display = 'inline-flex';
//       } else {
//         msg.style.display = 'none';
//       }
//     });
//   });
// }
// document.addEventListener('DOMContentLoaded', () => {
//   updatePromoMessages();

//   const observer = new MutationObserver(() => {
//     updatePromoMessages();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });

